/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gym_Id_TakenInputs */

const en_us2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That gym could not be saved. Try again.`)
};

const pt_br2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para salvar essa academia. Tente de novo.`)
};

const es_419_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar ese gimnasio. Inténtalo de nuevo.`)
};

const pt_pt2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível guardar esse ginásio. Tenta de novo.`)
};

const fr_fr2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer cette salle. Réessaie.`)
};

const de_de2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Studio konnte nicht gespeichert werden. Versuch es erneut.`)
};

const it_it2_gym_id_taken = /** @type {(inputs: Gym_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile salvare questa palestra. Riprova.`)
};

/**
* | output |
* | --- |
* | "That gym could not be saved. Try again." |
*
* @param {Gym_Id_TakenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_id_taken = /** @type {((inputs?: Gym_Id_TakenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Id_TakenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_id_taken(inputs)
	if (locale === "es-419") return es_419_gym_id_taken(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_id_taken(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_id_taken(inputs)
	if (locale === "de-DE") return de_de2_gym_id_taken(inputs)
	if (locale === "it-IT") return it_it2_gym_id_taken(inputs)
	return en_us2_gym_id_taken(inputs)
});
export { gym_id_taken as "gym.id_taken" }